export default {
  signIn: 'Sign In',
  logIn: 'Log In',
  facebookSignIn: 'Continue with Facebook',
  register: 'Create Account',
  forgot: 'Forgot Password',
  save: 'Save Changes',
  contactInfo: 'Account Information',
  reset: 'Reset Password',
  backToLogin: 'Return to Log in',
  startForFree: 'Start for free',

  // Placeholders
  passwordPlaceholder: 'Password (min. 8 characters)',
  newPasswordPlaceholder: 'New password',
  confirmPasswordPlaceholder: 'Confirm password',

  // Texts
  forgotPasswordStatement: 'Forgot password?',
  existingAccountText: 'Already have an account?',
  resetPasswordText: 'Enter your email to reset your password.',
  checkEmailText:
    'You have been sent an e-mail with instructions to reset your password.',
  newPasswordText: 'Reset the password of your Soundtracks account.',
  newPasswordSuccessText: 'You have successfully reset your password!',
  acceptLegalAgreementsText:
    "By signing up I agree to Loudly's <0>Terms of Use</0>, <1>Privacy Policy</1> and <2>License Agreement</2>.",
  noAccount: "Don't have an account?",
  noCreditCard: 'No Credit Card required.',

  // can be removed in the future
  registrationSuccess: 'Registration complete',
  updateSuccess: 'Contact information updated',
};
